import {
    GET_LIVE_LISTING_COUNT,
    GET_PAST_LISTING_COUNT,
    GET_ARTIST,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_ARTIST,
    GET_ARTIST_NEWS,
    CLEAR_ARTIST_NEWS,
} from './artistTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_LIVE_LISTING_COUNT:
            return {
                ...state,
                live_listing: action.payload,
            }
        case GET_ARTIST:
            return {
                ...state,
                artist_detail: action.payload,
            }
        case GET_ARTIST_NEWS:
            return {
                ...state,
                artistNews: action.payload,
            }
        case CLEAR_ARTIST_NEWS:
            return {
                ...state,
                artistNews: [],
            }
        case GET_ALL_ARTIST:
            return {
                ...state,
                all_artists: action.payload,
            }
        case GET_PAST_LISTING_COUNT:
            return {
                ...state,
                past_listing: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
